module.exports = "/_next/static/images/96dcebbeb809f4feda71307e6f798d42-NU_ComplianceTeam_ParkerLogo-08 1_lg.png.webp";